import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.svg'
import _imports_1 from '../assets/no-ordini.svg'


const _withScopeId = n => (_pushScopeId("data-v-7266e3e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "home"
}
const _hoisted_2 = { class: "bg-orange-600 h-16 flex justify-between content-center sticky top-0 z-10 shadow-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-lg text-white text-center mx-4 self-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    width: "70",
    alt: "logo l'angolo della frutta"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "container mx-auto px-4 py-4" }
const _hoisted_14 = {
  key: 0,
  class: "products-list"
}
const _hoisted_15 = { class: "text-center text-sm mb-5 pb-3 border-b border-solid border-gray-300" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Ordini del giorno ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between align-center px-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "flex-none mr-6 h-5 w-5" }),
  /*#__PURE__*/_createElementVNode("span", { class: "nome-cliente flex-1 text-left uppercase text-xs" }, "Prodotto"),
  /*#__PURE__*/_createElementVNode("span", { class: "qta-cliente flex-none uppercase text-xs" }, "q.tà")
], -1))
const _hoisted_18 = { class: "mb-4" }
const _hoisted_19 = {
  key: 1,
  class: "text-center text-gray-400 mt-10"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "no-ordini m-auto",
  src: _imports_1,
  alt: "nessun ordine al momento"
}, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "nessun ordine presente", -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Login = _resolveComponent("Login")!
  const _component_RigaProdotto = _resolveComponent("RigaProdotto")!
  const _component_PullRefresh = _resolveComponent("PullRefresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loggedIn)
      ? (_openBlock(), _createBlock(_component_Login, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.loggedIn)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              class: "mx-4 self-center text-white",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetChecked && _ctx.resetChecked(...args))),
              type: "button"
            }, _hoisted_5),
            _createElementVNode("button", {
              class: "mx-4 self-center text-white",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTutti && _ctx.toggleTutti(...args))),
              type: "button"
            }, [
              (!_ctx.apriTutti)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_9))
                : _createCommentVNode("", true),
              (_ctx.apriTutti)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_12))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_PullRefresh, {
            modelValue: _ctx.loading,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
            onRefresh: _ctx.onRefresh,
            "pulling-text": "Aggiorna",
            "loosing-text": "Rilascia per aggiornare",
            "loading-text": "Aggiornamento...",
            "success-text": "Aggiornato",
            "success-duration": "1000"
          }, {
            default: _withCtx(() => [
              _createElementVNode("main", _hoisted_13, [
                (Object.keys(_ctx.prodotti).length)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_14, [
                      _createElementVNode("p", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("strong", null, _toDisplayString(_ctx.giorno), 1)
                      ]),
                      _hoisted_17,
                      _createElementVNode("ul", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prodotti, (prodotto, index) => {
                          return (_openBlock(), _createBlock(_component_RigaProdotto, {
                            key: index,
                            prodotto: prodotto,
                            chiuso: _ctx.chiusi[index],
                            onToggle: ($event: any) => (_ctx.toggle(index)),
                            "data-id": prodotto.id
                          }, null, 8, ["prodotto", "chiuso", "onToggle", "data-id"]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!Object.keys(_ctx.prodotti).length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _hoisted_22))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}